import JSX, {h, Component, AnyComponent, ComponentChildren} from 'preact'
import TextButton from '../ui-components/TextButton'
import {isFunction} from "../../libs/preact-entry";
import 'element-closest-polyfill'

interface Props {
  triggerClass?: string,
  class?: string,
  triggerElement?: AnyComponent<{onClick: (e: Event) => void, disabled?: boolean}> | string,
  trigger?: ComponentChildren,
  children: JSX.Element,
  closeOnDropdownClick?: boolean,
  disabled?: boolean
}

interface State {
  isOpen: boolean,
}

export default class extends Component<Props, State> {
  root: null | HTMLElement

  constructor () {
    super()
    this.root = null
    this.documentClick = this.documentClick.bind(this)
  }

  addHandler () {
    window.document.addEventListener('click', this.documentClick)
  }

  removeHandler () {
    window.document.removeEventListener('click', this.documentClick)
  }

  documentClick (e: MouseEvent) {
    function isNode (e: EventTarget | null): e is HTMLElement {
      return !!e && 'childNodes' in e
    }
    if (!this.root) return
    if (!isNode(e.target)) return
    if (!this.props.closeOnDropdownClick && this.root.contains(e.target)) return
    if(e.target?.closest('form.live-edit__form.active') !== null) return
    this.removeHandler()
    this.setState({ isOpen: false })
  }

  render (props: Props) {
    const Trigger = props.triggerElement || TextButton
    return <div className={props.triggerClass} ref={ref => { this.root = ref }}>
      <Trigger
        disabled={props.disabled}
        onClick={(e: Event) => {
          if (props.disabled) {
            return
          }
          if (!this.state.isOpen) {
            this.addHandler()
            e.stopPropagation()
          } else {
            this.removeHandler()
          }
          this.setState({ isOpen: !this.state.isOpen })
        }}>
        {props.trigger}
      </Trigger>
      {this.state.isOpen
        ? <div class={props.class}>
            {isFunction(props.children[0]) && props.children[0]({
              close: () => this.setState({ isOpen: false })
            })}
          {props.children}
        </div>
        : null}
    </div>
  }
}
